import React, { useState } from "react";
import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const admissionClasses = [
  { id: "kiddy", label: "KIDDY", title: "KIDDY" },
  { id: "kg1", label: "KG I", title: "KG I" },
  { id: "kg2", label: "KG II", title: "KG II" },
  { id: "class1", label: "CLASS 1", title: "CLASS I" },
  { id: "class2", label: "CLASS 2", title: "CLASS II" },
  { id: "class3", label: "CLASS 3", title: "CLASS III" },
  { id: "class4", label: "CLASS 4", title: "CLASS IV" },
  { id: "class5", label: "CLASS 5", title: "CLASS V" },
  { id: "class6", label: "CLASS 6", title: "CLASS VI" },
  { id: "class7", label: "CLASS 7", title: "CLASS VII" },
  { id: "class8", label: "CLASS 8", title: "CLASS VIII" },
  { id: "class9", label: "CLASS 9", title: "CLASS IX" },
];

const Admission = () => {
  const [activeTab, setActiveTab] = useState("kiddy");

  const activeClass = admissionClasses.find((item) => item.id === activeTab);

  return (
    <>
      <Header />

      {/* ================= BREADCRUMB ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Academics"
          title2=""
          parentTitle="About"
          path="Admission & Withdrawal"
        />
      </div>

      {/* ================= MAIN CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="contact-form-card manage">
            <h2 className="about-title">Admission &amp; Withdrawal</h2>

            <div className="about-content-card">
              <section className="bodypart">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12" id="admission_open_container">
                      {/* ================= TAB BUTTONS ================= */}
                      <ul
                        className="nav nav-tabs d-flex flex-wrap gap-2"
                        id="admissionTabs"
                        role="tablist"
                      >
                        {admissionClasses.map((item) => {
                          const isActive = activeTab === item.id;

                          return (
                            <li
                              className="nav-item"
                              role="presentation"
                              key={item.id}
                            >
                              <button
                                type="button"
                                className={`nav-link ${isActive ? "active" : ""}`}
                                id={`${item.id}-tab`}
                                role="tab"
                                aria-controls={item.id}
                                aria-selected={isActive}
                                onClick={() => setActiveTab(item.id)}
                              >
                                {item.label}
                              </button>
                            </li>
                          );
                        })}
                      </ul>

                      {/* ================= ACTIVE TAB CONTENT ================= */}
                      <div className="tab-content" id="admissionTabContent">
                        {activeClass && (
                          <div
                            className="tab-pane fade show active"
                            id={activeClass.id}
                            role="tabpanel"
                            aria-labelledby={`${activeClass.id}-tab`}
                          >
                            <div className="container py-4">
                              <div className="row">
                                <div className="col-xl-12">
                                  <div className="contents">
                                    {/* ================= HEADING ================= */}
                                    <div className="content-heading text-center">
                                      <p>
                                        <strong>
                                          CARMEL SCHOOL, SARANGABAD, KOLKATA
                                        </strong>
                                      </p>

                                      <p>
                                        <strong>NOTICE FOR ADMISSION</strong>
                                      </p>

                                      <p>
                                        <strong>{activeClass.title}</strong>
                                      </p>

                                      <p>
                                        <strong>
                                          ACADEMIC SESSION: 2026-2027
                                        </strong>
                                      </p>

                                      <p>
                                        <strong>INTERACTION LIST</strong>
                                      </p>
                                    </div>

                                    {/* ================= CONTENT ================= */}
                                    <div className="content-section">
                                      <p>
                                        Both parents of the candidate are
                                        required to come to school along with
                                        their child for an interview, as per the
                                        schedule given. The original
                                        Certificates of the candidate must be
                                        brought for verification.
                                      </p>

                                      {/* ================= KIDDY ================= */}
                                      {activeClass.id === "kiddy" && (
                                        <ul>
                                          <li>
                                            <a
                                              href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/pdf/interaction-list-kiddy.pdf"
                                              id="interaction-list-kiddy"
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              Click here to view and download
                                              Interaction List for KIDDY
                                            </a>
                                          </li>

                                          <li>
                                            <a
                                              href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/pdf/FINAL-LIST-KIDDY-1ST-PHASE.pdf"
                                              id="interaction-date-time-kiddy"
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              Click here to view and download
                                              Final List
                                            </a>
                                          </li>
                                        </ul>
                                      )}

                                      {/* ================= KG I / KG II ================= */}
                                      {(activeClass.id === "kg1" ||
                                        activeClass.id === "kg2") && (
                                        <ul>
                                          <li>
                                            <a
                                              href="#"
                                              id={`interaction-list-${activeClass.id}`}
                                              onClick={(e) =>
                                                e.preventDefault()
                                              }
                                            >
                                              Click here to view and download
                                              Interaction List for{" "}
                                              {activeClass.label}
                                            </a>
                                          </li>

                                          <li>
                                            <a
                                              href="#"
                                              id={`interaction-date-time-${activeClass.id}`}
                                              onClick={(e) =>
                                                e.preventDefault()
                                              }
                                            >
                                              Click here to check Interaction
                                              Date and Time
                                            </a>
                                          </li>
                                        </ul>
                                      )}

                                      {/* ================= CLASS 1 TO CLASS 9 ================= */}
                                      {activeClass.id.startsWith("class") && (
                                        <ul>
                                          <li>
                                            <a
                                              href="#"
                                              id={`interaction-list-${activeClass.id}`}
                                              onClick={(e) =>
                                                e.preventDefault()
                                              }
                                            >
                                              Click here to view and download
                                              Interaction List for{" "}
                                              {activeClass.title}
                                            </a>
                                          </li>

                                          <li>
                                            <a
                                              href="#"
                                              id={`interaction-date-time-${activeClass.id}`}
                                              onClick={(e) =>
                                                e.preventDefault()
                                              }
                                            >
                                              Click here to check Interaction
                                              Date and Time
                                            </a>
                                          </li>
                                        </ul>
                                      )}
                                    </div>

                                    {/* ================= FOOTER ================= */}
                                    <div className="row mt-4">
                                      <div className="col-xl-12">
                                        <div className="foot d-flex justify-content-between align-items-end">
                                          <div className="date">
                                            <p>08.08.2025</p>
                                          </div>

                                          <div className="principal">
                                            <img
                                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/digital-sign.png"
                                              alt="Digital Signature"
                                              className="img-fluid"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Admission;
